export default __webpack_public_path__ + "static/media/Clinica-Cachoeirinha.418d0a3e.png";